import moment from "antd/node_modules/moment";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { RegionFilterStore } from "../RegionFilterStore";
import { RootStore } from "../Store";
import { FundEditStore } from "./FundEditStore";
import { FundStore } from "./FundStore";

export class FundsStore {
  rootStore: RootStore;
  fundView: FundStore;
  fundEdit: FundEditStore;
  loading = false;

  filterStore: RegionFilterStore;

  filter: any = {
    page: 0,
    size: 20,
    pending: true,
    regionId: "",
    divisionId: "",
    communityId: "",
    period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "start", order: "descend" };

  data = {
    total: 0,
    avgApprovalTime: "",
    items: [],
  };

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
      pagination: computed,
    });
    this.rootStore = rootStore;
    this.filterStore = new RegionFilterStore(this);
    this.filterStore.notReset = ["pending"];
    this.fundView = new FundStore(this);
    this.fundEdit = new FundEditStore(this);
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: string[] = [];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    console.log("query", params);
    const pending = params.get("pending") !== "false";
    const regionId = params.get("regionId") || "";
    const divisionId = params.get("divisionId") || "";
    const communityId = params.get("communityId") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");
    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    console.log("p", period);
    this.filter = { pending, regionId, divisionId, communityId, period, page, size };
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { regionId, divisionId, communityId, period, pending, page, size } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];

    const filter: any = {
      regionId,
      divisionId,
      communityId,
      pending,
      page,
      size,
      sorts,
    };
    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }
    Api.fr
      .fundraisings(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.fundraisers;
        });
      })
      .finally(() => (this.loading = false));
  }

  @action
  active(id: string) {
    this.fundView.active(id);
  }
}
